var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37510_349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6V16H6V6H8.07851H10Z",
    fill: "#16A0D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 1V16.0672H13.6562H16V1H11.3125Z",
    fill: "#16A0D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 16.4398H1V10H4.6875V16.4398Z",
    fill: "#16A0D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37510_349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonding);
export default __webpack_public_path__ + "static/media/bonding.dedcb30c85a695238e9f3a43211bd1d5.svg";
export { ForwardRef as ReactComponent };